import React, { FunctionComponent } from 'react'
import { Button, Grid, Text, usePercent } from '@afterpaytouch/core'
import { ConsumerLendingPaymentSchedule, Money, PaymentOptionsModal } from '..'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from 'next-i18next'
import { useAppRouter, useIsConsumerLendingOrder, useSelectedPaymentOption } from '../../state'
import { create } from 'react-modal-promise'
import styles from './style.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'

export const ConsumerLendingPlanDetails: FunctionComponent = () => {
  const { t } = useTranslation()
  const { sectionHeadingSize, textSize } = useCheckoutSizes()
  const selectedPaymentOption = useSelectedPaymentOption()
  const isConsumerLending = useIsConsumerLendingOrder()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const { locale } = useAppRouter()
  const { formatPercent } = usePercent({ locale, decimalPlaces: 2, shouldDivideBy100: true })

  const showPaymentOptionsModal = create(PaymentOptionsModal)

  if (typeof selectedPaymentOption === 'undefined' || !isConsumerLending) {
    return null
  }

  const apr = formatPercent(selectedPaymentOption.apr)

  return (
    <>
      <div className={styles.heading}>
        <Text size={sectionHeadingSize} bold>
          {t('consumerLending:summary:planDetails')}
        </Text>
        <Button.Secondary
          onClick={() => {
            logEvent(TrackingEvent.PRESSED_CL_PLAN_EDIT_BUTTON)
            showPaymentOptionsModal()
          }}
          size='Small'
          testNameSpace='consumer-lending-plan-details'
        >
          {t('common:edit')}
        </Button.Secondary>
      </div>
      <Grid>
        <Text size={textSize} renderAs='span'>
          {t('consumerLending:summary:apr')}
        </Text>
        <Grid.Item sm='auto'>
          <Text size={textSize} renderAs='span' testNameSpace='consumerLendingPlanDetails-apr'>
            {apr}
          </Text>
        </Grid.Item>
      </Grid>
      <Grid>
        <Text size={textSize} renderAs='span'>
          {t('consumerLending:summary:interest')}
        </Text>
        <Grid.Item sm='auto' data-testid='consumerLendingPlanDetails-interestAmount'>
          <Money value={selectedPaymentOption.interestAmount} size={textSize} />
        </Grid.Item>
      </Grid>
      <Grid>
        <Text size={textSize} renderAs='span'>
          {t('consumerLending:summary:total')}
        </Text>
        <Grid.Item sm='auto' data-testid='consumerLendingPlanDetails-totalAmount'>
          <Money value={selectedPaymentOption.totalAmount} size={textSize} />
        </Grid.Item>
      </Grid>
      <ConsumerLendingPaymentSchedule />
    </>
  )
}
